import PropTypes from 'prop-types';
import React from 'react';

import Loader from 'Component/Loader';
// import RadioButton from 'Component/RadioButtonIcon';
import {
    MyAccountAddressTable as SourceMyAccountAddressTable
} from 'SourceComponent/MyAccountAddressTable/MyAccountAddressTable.component';

import './MyAccountAddressTable.override.style';

/** @namespace PeggysagePwa/Component/MyAccountAddressTable/Component */
export class MyAccountAddressTableComponent extends SourceMyAccountAddressTable {
    static propTypes = {
        ...SourceMyAccountAddressTable.propTypes,
        onChooseAsDefaultShippingClick: PropTypes.func.isRequired,
        onChooseAsDefaultBillingClick: PropTypes.func.isRequired,
        showQuickEdit: PropTypes.bool.isRequired,
        isLoading: PropTypes.bool.isRequired,
        canChangeBillingAddress: PropTypes.bool.isRequired
    };

    /**
     * Override
     * @returns {JSX.Element|null}
     */
    renderHeading() {
        const {
            title
            // isSelected
        } = this.props;

        if (!title) {
            return null;
        }

        return (
            <h3 block="MyAccountAddressTable" elem="Heading">
                { title }
                { /* <RadioButton isActive={ isSelected } /> */ }
            </h3>
        );
    }

    renderAddressLine(data) {
        const { key/* , label */ } = data;
        const value = this.getValueFromSource(data); // from KeyValueTable component

        if (!value) {
            return null;
        }

        return (
            <li key={ key } data-key={ key }>
                { value }
            </li>
        );
    }

    renderContent() {
        return (
            <div block="MyAccountAddressTable" elem="Content">
                <address>
                    <ul>
                        { this.dataPairArray.map(this.renderAddressLine.bind(this)) }
                    </ul>
                </address>
            </div>
        );
    }

    renderQuickEditDefaultShipping() {
        const {
            address: { default_shipping, default_billing },
            onChooseAsDefaultShippingClick,
            canChangeBillingAddress
        } = this.props;

        if (default_shipping || (default_billing && !canChangeBillingAddress)) {
            return null;
        }

        return (
            <div block="MyAccountAddressTable" elem="QuickEditButton">
                <button
                  type="button"
                  block="Button"
                  mods={ { likeLink: true } }
                  onClick={ onChooseAsDefaultShippingClick }
                >
                    { __('Choose as default shipping address') }
                </button>
            </div>
        );
    }

    renderQuickEditDefaultBilling() {
        const { address: { default_billing }, onChooseAsDefaultBillingClick, canChangeBillingAddress } = this.props;

        if (default_billing || !canChangeBillingAddress) {
            return null;
        }

        return (
            <div block="MyAccountAddressTable" elem="QuickEditButton">
                <button
                  type="button"
                  block="Button"
                  mods={ { likeLink: true } }
                  onClick={ onChooseAsDefaultBillingClick }
                >
                    { __('Choose as default billing address') }
                </button>
            </div>
        );
    }

    renderQuickEdit() {
        const { address: { default_billing, default_shipping }, showQuickEdit } = this.props;

        if (!showQuickEdit || (default_billing && default_shipping)) {
            return null;
        }

        return (
            <div block="MyAccountAddressTable" elem="QuickEdit">
                { this.renderQuickEditDefaultShipping() }
                { this.renderQuickEditDefaultBilling() }
            </div>
        );
    }

    /**
     * Override
     * @returns {JSX.Element}
     */
    renderTable() {
        return (
            <div block="MyAccountAddressTable" elem="Wrapper">
                { this.renderHeading() }
                { this.renderContent() }
            </div>
        );
    }

    /**
     * Override: add wrapper, change button label, fix untranslated string
     * @returns {JSX.Element|null}
     */
    renderActions(showDelete = true) {
        const {
            onEditClick,
            onDeleteClick,
            showActions,
            address: { default_billing, default_shipping },
            canChangeBillingAddress
        } = this.props;

        const isDeletionDisabled = default_shipping || default_billing;
        const isModificationDisabled = default_billing && !canChangeBillingAddress;

        if (!showActions) {
            return null;
        }

        return (
            <div block="MyAccountAddressTable" elem="Actions">
                <button
                  block="Button"
                  onClick={ onEditClick }
                  disabled={ isModificationDisabled }
                  mods={ { likeLink: true, modify: true } }
                >
                    { __('Modify') }
                </button>
                { showDelete && (
                    <button
                      block="Button"
                      mods={ { likeLink: true, delete: true } }
                      onClick={ onDeleteClick }
                      disabled={ isDeletionDisabled }
                      title={ isDeletionDisabled ? __('Can not delete - address is set as default.') : __('Delete this address') }
                    >
                        { __('Delete') }
                    </button>
                ) }
            </div>
        );
    }

    /**
     * Override
     * @returns {JSX.Element}
     */
    render() {
        const { countries, mix, isLoading } = this.props;

        return (
            <div block="MyAccountAddressTable" mix={ mix }>
                <Loader isLoading={ isLoading || !countries.length } />
                { this.renderTable() }
                { this.renderActions() }
                { this.renderQuickEdit() }
            </div>
        );
    }
}

export default MyAccountAddressTableComponent;
